import {
  GetGoodReceiptDetails,
  moveMrn,
  movemrncarton,
  moveItemSale,
  moveGrv,
  addBulkUploads,
  getBulkUploads,
  downloadLogFile,
  downloadBulkFile,
  stockUploadfilter,
  deleteVendor,
  createIpPool,
} from "@/http/inventory";

export default {
  namespaced: true,
  state: {
    goodReceipt: {
      list: [],
      isLoading: false,
    },
    bulkUploads: [],
    filteredStock: "",
  },
  actions: {
    async setUser({ commit }) {
      try {
        commit({ LOADING_GOOD_RECEIPT_DETAILS });
        const goodReceiptDetails = await GetGoodReceiptDetails();

        commit(GET_GOOD_RECEIPT_DETAILS, data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setBulkUploads({ commit }) {
      try {
        const response = await getBulkUploads();
        const data = response.data;
        commit("SET_BULK_UPLOADS", data);
        return data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async moveMrnAction(_, data) {
      try {
        let response = await moveMrn(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createIpPoolAction(_, data) {
      try {
        return await createIpPool(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteVendorAction(_, data) {
      try {
        let response = await deleteVendor(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async stockUploadfilterAction({ commit }, payload) {
      try {
        const resp = await stockUploadfilter(
          payload.status,
          payload.entityName,
          payload.description
        );
        commit("SET_STOCK_UPLOAD_FILTER", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async movemrncartonAction(_, data) {
      try {
        let response = await movemrncarton(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async moveGrvAction(_, data) {
      try {
        let response = await moveGrv(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async moveSaleAction(_, data) {
      try {
        let response = await moveItemSale(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async bulkUploadAction(_, data) {
      try {
        let response = await addBulkUploads(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async downloadLogFileAction(_, data) {
      try {
        let response = await downloadLogFile(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async downloadFileAction(_, data) {
      try {
        let response = await downloadBulkFile(data);
        return response;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    LOADING_GOOD_RECEIPT_DETAILS(state, payload) {
      Object.assign(state.goodReceipt.isLoading, true);
    },
    SET_BULK_UPLOADS(state, payload) {
      Object.assign(state, { bulkUploads: payload });
    },
    SET_STOCK_UPLOAD_FILTER(state, payload) {
      state.filteredStock = payload;
    },
  },
  getters: {
    getGoodReceiptList(state) {
      return state.goodReceipt.list;
    },
    goodReceiptIsLoading(state) {
      return state.goodReceipt.isLoading;
    },
    getBulkUploads(state) {
      return state.bulkUploads;
    },
  },
};
